import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from "@/components/ui/credenza"
import ConnectionStatusForm from "@/components/forms/connection-status-form"
import { Icons } from "@/components/icons"

export const Route = createFileRoute(
  '/_home/meter-connection-settings/connection-status/add',
)({
  component: AddConnectionStatusPage,
})

export default function AddConnectionStatusPage() {
  const [showAddConnectionStatusModal, setShowAddConnectionStatusModal] =
    React.useState<boolean>(false)
  return (
    <main>
      {/*   <Dialog>
        <DialogTrigger asChild>
          <Button>
            <Icons.add className="size-4" />
            Add Connection Status
          </Button>
        </DialogTrigger>
        <DialogContent className="md:max-w-[850px]">
          <ConnectionStatusForm />
          <DialogFooter className="flex flex-row justify-end gap-2 md:mr-4">
            <DialogClose>
              <Button variant="outline" type="submit" className="w-28">
                Cancel
              </Button>
            </DialogClose>
            <Button type="submit" className="w-28">
              Add
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog> */}
      <div className="flex w-full justify-end">
        <Button
          onClick={() => {
            {
              if (!validateUserAddPermission()) return
              setShowAddConnectionStatusModal(true)
            }
          }}
        >
          <Icons.add className="size-4" />
          Add Connection Status
        </Button>
      </div>
      <Credenza
        open={showAddConnectionStatusModal}
        onOpenChange={setShowAddConnectionStatusModal}
      >
        <CredenzaContent className="flex w-full max-w-[850px] justify-center">
          <CredenzaBody>
            <ConnectionStatusForm
              setShowAddConnectionStatusModal={setShowAddConnectionStatusModal}
            />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
